export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10900.87c849e0.jpg";